module.exports = __webpack_public_path__ + "static/media/free.5d9f97f3.svg";